import { Clear, Search } from '@mui/icons-material'
import { Box, IconButton, InputAdornment, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import customTheme from '../lib/customTheme';

const BuscarEmpresas = ({ cerrar = () => { }, buscar }) => {
    // const outerTheme = useTheme();
    const [textoBusqueda, setTextoBusqueda] = useState('');
    const limpiarBusqueda = () => {
        setTextoBusqueda('');
    };
    useEffect(() => {
        buscar(textoBusqueda);
    }, [textoBusqueda]);
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', color: '#000', width: '100%' }}>
            {/* <ThemeProvider theme={customTheme(outerTheme)}> */}
            <TextField
                sx={{ 
                    width: '100%',
                    input: { color: '#000' } 
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search sx={{ color: '#000' }} />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            {textoBusqueda && (
                                <IconButton onClick={limpiarBusqueda} edge="end">
                                    <Clear sx={{ color: '#000' }} />
                                </IconButton>
                            )}
                        </InputAdornment>
                    ),
                }}
                name="buscador"
                label="Buscar..."
                onBlur={cerrar}
                autoFocus
                color="primary"
                variant="standard"
                value={textoBusqueda}
                onChange={(e) => setTextoBusqueda(e.target.value)}
            />
            {/* </ThemeProvider> */}
        </Box>
    )
}

export default BuscarEmpresas